/**
 * Full-height centered fallback shown in place of a page or list when the
 * caller lacks the view permission required to see it. Extracted from three
 * near-identical implementations across the media-units, clients, and
 * suppliers features.
 */
export interface PermissionDeniedStateProps {
  /** Translated permission-denied message. */
  message: string;
  /** Optional data-testid for the wrapper. Omitted entirely when not provided. */
  testId?: string;
}

export function PermissionDeniedState({ message, testId }: PermissionDeniedStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full py-20" data-testid={testId}>
      <p className="text-base text-muted-foreground">{message}</p>
    </div>
  );
}
